import { PaymentPartnerType } from '../../codegen/vehicles';
import { PaymentPartnerIcon } from '../icons/PaymentPartnerIcon';

export const ServiceCardRepresentationNumberRepresentation = ({
  paymentPartner,
  lastFourDigits,
}: {
  paymentPartner: PaymentPartnerType;
  lastFourDigits: string;
}) => {
  return (
    <div>
      <PaymentPartnerIcon
        paymentPartner={paymentPartner}
        className="height-20"
      />
      <span> *** {lastFourDigits}</span>
    </div>
  );
};
